<template>
  <div>
    <div class="footer_menu">
      <div
        v-for="menu in menus"
        :key="menu.label"
        class="menu_item"
        @click="handleClick(menu)"
      >
        <div class="icon_frame">
          <img :src="menu.image" :alt="menu.label" :class="{ coin: menu.isCoin, about: menu.isAbout }" />
        </div>
        <span class="label">{{ menu.label }}</span>
      </div>
    </div>
    <AboutSiteDialog
      :isVisible="showAboutDialog"
      @close="showAboutDialog = false"
    />
  </div>
</template>

<script>
import AboutSiteDialog from '@/components/organisms/AboutSiteDialog.vue';
import t from '@/plugins/i18n';

export default {
  mixins: [t],

  components: {
    AboutSiteDialog,
  },

  data() {
    return {
      showAboutDialog: false,
    };
  },

  computed: {
    aboutLabel() {
      return this.t('サイトについて');
    },
    menus() {
      return [
        {
          url: '',
          image: '/img/menu/about_site.png',
          label: this.aboutLabel,
          isAbout: true,
        },
        {
          url: '/buy-point',
          image: '/img/star_coin.webp',
          label: this.t('コイン購入'),
          isCoin: true,
        },
        {
          url: '/undecided-detail',
          image: '/img/menu/history.png',
          label: this.t('購入履歴'),
        },
        {
          url: '/change-member',
          image: '/img/menu/mypage.png',
          label: this.t('登録情報'),
        },
      ];
    },
  },

  methods: {
    handleClick(menu) {
      if (menu.label === this.aboutLabel) {
        this.showAboutDialog = true;
        return;
      }
      if (menu.url) {
        this.$router.push(menu.url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.footer_menu {
  position: fixed;
  left: 0;
  bottom: 0;
  width: -webkit-fill-available;
  z-index: 10;
  background-color: #fff;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 5px;
  padding: 5px;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 2.1);
}

.menu_item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 4px 8px;

  .icon_frame {
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      height: 36px;
      width: auto;
      max-width: 60px;
      object-fit: contain;

      // star_coinは640x480の横長で上下に余白があるため大きめに
      &.coin {
        height: 44px;
      }
      // about_siteは外周にリングと透明余白があるため大きめに
      &.about {
        height: 42px;
      }
    }

    @media screen and (max-width: $tabletWidth) {
      height: 34px;

      img {
        height: 28px;
        max-width: 48px;

        &.coin {
          height: 34px;
        }
        &.about {
          height: 33px;
        }
      }
    }
  }

  .label {
    margin-top: 4px;
    color: #6e6d6d;
    font-size: 14px;
    font-weight: bold;
    line-height: 1;

    @media screen and (max-width: $tabletWidth) {
      font-size: 10px;
    }
  }
}
</style>
